import React from 'react';
import { VictoryBar, VictoryTooltip } from 'victory';
import InfoCardWidget from './infoCardWidget';
import './statisticsWidget.css';

const InfoCardWithVerticalBarChartWidget =
  ({ primaryColor, secondaryColor, title, icon, data, chartData, comment, barTooltip, loading }) => {

    const primaryBarColor = '#2fa3e3';
    let barWidth = 450.0 / (chartData && chartData.length || 1);
    const gapWidth = 7 * barWidth / 100.0;
    barWidth = barWidth - gapWidth;

    const onBarMouseOver = () => {
      return [
        {
          target: 'data',
          mutation: ({ style }) => ({ style: { ...style, fill: primaryColor } })
        },
        {
          target: 'labels',
          mutation: () => ({ active: true })
        }
      ];
    };

    const onBarMouseOut = () => {
      return [
        {
          target: 'data',
          mutation: ({ style }) => ({ style: { ...style, fill: primaryBarColor } })
        },
        {
          target: 'labels',
          mutation: () => ({ active: false })
        }
      ];
    };

    return (
      <InfoCardWidget { ...{ primaryColor, secondaryColor, title, icon, data, comment, loading } }>
        {
          chartData && chartData.length > 0 &&
            <div className="chart-container">
              <VictoryBar labelComponent={<VictoryTooltip/>} labels={barTooltip}
                          events={[{ target: 'data', eventHandlers: { onMouseOver: onBarMouseOver, onMouseOut: onBarMouseOut } }]}
                          data={chartData.map(item => ({ ...item, width: barWidth }))} padding={ { top: 0, bottom: 0, right: 10, left: 10 } }
                          style={{ data: { fill: primaryBarColor } }} domainPadding={{x: barWidth / 2.0}}
              />
            </div>
        }

      </InfoCardWidget>
    );
};

export default InfoCardWithVerticalBarChartWidget;



// WEBPACK FOOTER //
// ./src/components/statisticsWidgets/infoCardWithVerticalBarChartWidget.js